import { apiAsync, stateList } from '../../../common/helpers'

const fetchPaidLeaveInformation = async (companyId) => {
  let states = []
  await apiAsync({
    api: `companies/${companyId}/locations/countByState`,
    params: { productName: 'paidLeave' },
    method: 'GET'
  }).then((response) => {
    states = response
  }).catch((error) => {
    console.error(`Error in fetchStatesByProduct(): ${error}`)
  })
  return states
}

const getMapData = async (companyId) => {
  // find out which states have paid leave topics and the counts impacted by them
  const statePaidLeaveInfo = await fetchPaidLeaveInformation(companyId)

  // build up a list for all the states (regardless of whether they have locations or products defined)
  const list = stateList.filter((state) => state.country === 'US').map((state) => {
    const stateAbbreviation = state.state
    const info = statePaidLeaveInfo[stateAbbreviation]

    let stateLocationCount = 0
    let hasProducts = false
    let paidLeave = { hasTopics: false, count: 0 }
    let paidFamilyMedicalLeave = { hasTopics: false, count: 0 }
    let paidSickLeave = { hasTopics: false, count: 0 }

    if (info) {
      stateLocationCount = info.locations
      hasProducts = (info.paidLeave.hasTopics || info.paidFamilyMedicalLeave.hasTopics || info.paidSickLeave.hasTopics)
      paidLeave = { hasTopics: info.paidLeave.hasTopics, count: info.paidLeave.affectedLocations }
      paidFamilyMedicalLeave = { hasTopics: info.paidFamilyMedicalLeave.hasTopics, count: info.paidFamilyMedicalLeave.affectedLocations }
      paidSickLeave = { hasTopics: info.paidSickLeave.hasTopics, count: info.paidSickLeave.affectedLocations }
    }

    return { hasProducts, products: { paidLeave, paidFamilyMedicalLeave, paidSickLeave }, stateLocationCount, stateAbv: stateAbbreviation, state: state.name }
  })

  return list
}

export default { getMapData }
